import BaseBlockMap from './BaseBlockMap';
import CorporateBlockMap from './CorporateBlockMap';


export default {
    ...BaseBlockMap,
    ...CorporateBlockMap,
};
